"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _utils = require("../utils");

var _AssetsList = _interopRequireDefault(require("./AssetsList"));

var _ManageAssetModal = _interopRequireDefault(require("./ManageAssetModal"));

var _ConfirmationModal = _interopRequireDefault(require("./ConfirmationModal"));

var _confirmActions = _interopRequireDefault(require("./ConfirmationModal/constants/confirmActions"));

require("../styles/_library.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    if (i % 2) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i]));
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CHUNK_SIZE = 16;

var Library = /*#__PURE__*/function (_Component) {
  _inherits(Library, _Component);

  function Library(props) {
    var _this;

    _classCallCheck(this, Library);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Library).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "showConfirmationModal", function (_ref) {
      var assetId = _ref.assetId,
          confirmModalAction = _ref.confirmModalAction;

      _this.setState({
        isConfirmModalOpen: true,
        confirmModalAction: confirmModalAction,
        assetId: assetId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchAssets", function () {
      _this.setState({
        loading: true
      }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, assetsMap, getAssets, getArchivedAssets, organisationId, archivedFilter, getAssetsRequest, assetField, _ref3, _ref3$data, assets, error, mergedAssets;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, assetsMap = _this$props.assetsMap, getAssets = _this$props.getAssets, getArchivedAssets = _this$props.getArchivedAssets, organisationId = _this$props.organisationId;
                archivedFilter = _this.state.archivedFilter;
                getAssetsRequest = archivedFilter === 'ARCHIVED' ? getArchivedAssets : getAssets;
                assetField = archivedFilter === 'ARCHIVED' ? 'getArchivedAssets' : 'getAssets';
                _context.next = 6;
                return getAssetsRequest();

              case 6:
                _ref3 = _context.sent;
                _ref3$data = _ref3.data;
                _ref3$data = _ref3$data === void 0 ? {} : _ref3$data;
                assets = _ref3$data[assetField], error = _ref3.error;

                if (!error) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", void _this.setState({
                  error: error
                }));

              case 12:
                mergedAssets = (0, _utils.mergeAssets)(assetsMap, assets, organisationId);

                _this.setState(function (prevState) {
                  return _objectSpread({}, prevState, {
                    assets: mergedAssets,
                    loading: false
                  });
                });

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.fetchAssets();
    });

    _defineProperty(_assertThisInitialized(_this), "updateAssets", function (assetsMap) {
      var organisationId = _this.props.organisationId;

      _this.setState(function (prevState) {
        var assets = prevState.assets;
        return _objectSpread({}, prevState, {
          assets: (0, _utils.mergeAssets)(assetsMap, assets, organisationId)
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var prevAssetsMap = prevProps.assetsMap,
          prevOrganisationId = prevProps.organisationId;
      var _this$props2 = _this.props,
          assetsMap = _this$props2.assetsMap,
          organisationId = _this$props2.organisationId; // update only for assets uploaded via Uploader

      if (prevAssetsMap !== assetsMap) {
        return void _this.updateAssets(assetsMap);
      } // update for organisation switch


      if (prevOrganisationId !== organisationId) {
        return void _this.fetchAssets();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeConfirmationModal", function () {
      _this.setState({
        isConfirmModalOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showManageAssetModal", function (_ref4) {
      var assetId = _ref4.assetId;

      _this.setState({
        isManageAssetModalVisible: true,
        assetId: assetId
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeManageAssetModal", function () {
      _this.setState({
        isManageAssetModalVisible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setFilePickerRef", function (ref) {
      _this._filePickerRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleUploadClick", function () {
      if (!_this._filePickerRef) {
        return;
      }

      _this._filePickerRef.openFileChooser();
    });

    _defineProperty(_assertThisInitialized(_this), "handleManageAssetModalSave", function (data) {
      _this.setState(function (_ref5) {
        var prevAssets = _ref5.assets;
        return {
          assets: (0, _utils.replaceAsset)(prevAssets, data.updateAsset)
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleModalConfirmation", function () {
      var removeFromAssetsMap = _this.props.removeFromAssetsMap;
      var _this$state = _this.state,
          assetId = _this$state.assetId,
          confirmModalAction = _this$state.confirmModalAction;

      if (Object.values(_confirmActions.default).includes(confirmModalAction)) {
        _this.setState(function (_ref6) {
          var assets = _ref6.assets;
          return {
            assets: (0, _utils.removeAsset)(assets, assetId)
          };
        });

        removeFromAssetsMap(assetId);
      }

      _this.closeConfirmationModal();
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteComplete", function (assetId) {
      var removeFromAssetsMap = _this.props.removeFromAssetsMap;

      _this.setState(function (_ref7) {
        var assets = _ref7.assets;
        return {
          assets: (0, _utils.removeAsset)(assets, assetId)
        };
      });

      removeFromAssetsMap(assetId);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFilterChange", function (_ref8) {
      var ARCHIVED_FILTER = _ref8.filters.ARCHIVED_FILTER,
          searchTerm = _ref8.searchTerm;
      var archivedFilter = _this.state.archivedFilter;

      if (archivedFilter === ARCHIVED_FILTER) {
        return void _this.setState({
          searchTerm: searchTerm
        });
      }

      _this.setState({
        searchTerm: searchTerm,
        archivedFilter: ARCHIVED_FILTER,
        displayedNum: CHUNK_SIZE
      }, function () {
        return _this.fetchAssets();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFilteredAssets", function () {
      var _this$state2 = _this.state,
          _this$state2$assets = _this$state2.assets,
          assets = _this$state2$assets === void 0 ? [] : _this$state2$assets,
          searchTerm = _this$state2.searchTerm;

      if (!assets) {
        return [];
      }

      if (!searchTerm) {
        return assets;
      }

      return assets.filter(function (item) {
        return Object.values(item).some(function (dataField) {
          return dataField && typeof dataField === 'string' && dataField.toLowerCase().includes(searchTerm.toLowerCase());
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragOver", function (e) {
      e.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragLeave", function (e) {
      if (!e || e.relatedTarget === null) {
        _this.setState({
          dropZoneDisplayed: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleDragEnter", function () {
      _this.setState({
        dropZoneDisplayed: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDropZone", function (e) {
      e.preventDefault();

      _this.setState({
        dropZoneDisplayed: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "showMore", function () {
      _this.setState(function (_ref9) {
        var prevNum = _ref9.displayedNum;
        return {
          displayedNum: prevNum + CHUNK_SIZE
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setListRef", function (ref) {
      if (!ref) {
        return;
      }

      _this._listRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "getListRef", function () {
      return _this._listRef;
    });

    _this.state = {
      isManageAssetModalVisible: false,
      isConfirmModalOpen: false,
      confirmModalAction: '',
      assetId: '',
      assets: void 0,
      displayedNum: CHUNK_SIZE,
      loading: true,
      dropZoneDisplayed: false,
      archivedFilter: ''
    };
    return _this;
  }

  _createClass(Library, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          history = _this$props3.history,
          organisationName = _this$props3.organisationName,
          deleteAsset = _this$props3.deleteAsset,
          orgPermissions = _this$props3.orgPermissions;
      var _this$state3 = this.state,
          isManageAssetModalVisible = _this$state3.isManageAssetModalVisible,
          assetId = _this$state3.assetId,
          confirmModalAction = _this$state3.confirmModalAction,
          isConfirmModalOpen = _this$state3.isConfirmModalOpen,
          loading = _this$state3.loading,
          dropZoneDisplayed = _this$state3.dropZoneDisplayed,
          archivedFilter = _this$state3.archivedFilter,
          error = _this$state3.error,
          displayedNum = _this$state3.displayedNum;

      if (error) {
        return _react.default.createElement(_commonReact.Error, null);
      }

      var results = this.getFilteredAssets();
      return _react.default.createElement("div", {
        className: "library",
        onDrop: this.closeDropZone,
        onDragLeave: this.handleDragLeave,
        onDragEnter: this.handleDragEnter,
        onDragOver: this.handleDragOver,
        ref: this.setListRef
      }, _react.default.createElement(_uiKit.PageHeader, {
        title: "Media Assets Library",
        subtitle: organisationName,
        actionBtnText: "Upload Assets",
        actionBtnOnClick: this.handleUploadClick
      }), _react.default.createElement(_AssetsList.default, {
        assets: results.slice(0, displayedNum),
        history: history,
        showConfirmationModal: this.showConfirmationModal,
        showModal: this.showManageAssetModal,
        setFilePickerRef: this.setFilePickerRef,
        handleFilterChange: this.handleFilterChange,
        loading: loading,
        dropZoneDisplayed: dropZoneDisplayed,
        closeDropZone: this.handleDragLeave,
        archivedFilter: archivedFilter,
        deleteAsset: deleteAsset,
        onDeleteComplete: this.onDeleteComplete,
        orgPermissions: orgPermissions,
        loadMoreResults: this.showMore,
        totalResults: results.length,
        getListRef: this.getListRef
      }), _react.default.createElement(_ManageAssetModal.default, {
        isVisible: isManageAssetModalVisible,
        assetId: assetId,
        handleClose: this.closeManageAssetModal,
        handleError: console.error,
        handleSave: this.handleManageAssetModalSave
      }), _react.default.createElement(_ConfirmationModal.default, {
        organisationName: organisationName,
        visible: isConfirmModalOpen,
        hideModal: this.closeConfirmationModal,
        assetId: assetId,
        confirmModalAction: confirmModalAction,
        onConfirmation: this.handleModalConfirmation
      }));
    }
  }]);

  return Library;
}(_react.Component);

exports.default = Library;